import { message } from 'ant-design-vue'
import {
  getPhysioPage, exportPhysioExcel, updateCommentStatusByEvaluationId, updatePhysionScore, updatePhysionOrderCount,
  updatePhysionAvailability, delPhysioById, getPhysioById, addPhysio, updatePhysio, getCommentPageByPhysioId,
  delCommentByEvaluationId
} from '@/api/home/physio'
import { useUserStore } from '@/store'

export class PhysioController {
  static async page (params: HOME.PHYSIO_QUERY_PARAMS) {
    const { data } = await getPhysioPage({
      ...params,
      category: useUserStore().userInfo.agent.category
    })
    return {
      data: data.records,
      sum: data.total
    }
  }

  static async byId (id: string) {
    return await getPhysioById(id)
  }

  static async exportExcel (params: HOME.PHYSIO) {
    return await exportPhysioExcel(params)
  }

  static async updatePhysionAvailability (params: {staffId: string, isAvailabie: boolean}) {
    const { code, msg } = await updatePhysionAvailability(params as any)
    code === 0 ? message.success('修改成功') : message.error(msg)
    return code
  }

  static async del (id: string) {
    const { code, msg } = await delPhysioById(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
    return code
  }

  static async add (params: HOME.PHYSIO) {
    const { code, msg } = await addPhysio({
      ...params,
      category: useUserStore().userInfo.agent.category
    })
    code === 0 ? message.success('新增成功') : message.error(msg)
    return code
  }

  static async update (params: HOME.PHYSIO) {
    const { code, msg } = await updatePhysio({
      ...params,
      category: useUserStore().userInfo.agent.category
    })
    code === 0 ? message.success('修改成功') : message.error(msg)
    return code
  }

  static async pageComment (params: { staffId: string} & API.Params) {
    return await getCommentPageByPhysioId(params)
  }

  static async updateCommentStatusByEvaluationId (params: { evaluationId: string, isDisplayed: string}) {
    return await updateCommentStatusByEvaluationId(params)
  }

  static async delCommenByEvaluationId (evaluationId: string) {
    const { code, msg } = await delCommentByEvaluationId(evaluationId)
    code === 0 ? message.success('删除成功') : message.error(msg)
    return code
  }
}
